import { useQuery } from '@tanstack/react-query';
import Fetch from '../../../../../../core/util/core/Fetch';
import config from '../../../../../config/config';

/**
 * Projeção populacional aritmética do município (Censos 2010 e 2022).
 * Devolve null quando falta um dos Censos (municípios criados depois de 2010).
 */
const useCensusPopulationProjection = cityId =>
    useQuery({
        queryKey: ['census-population-projection', cityId],
        queryFn: async () => {
            const response = await Fetch.post(
                config.endpoints.backend + 'governanceroom/sectors/census/population-projection',
                { city_id: cityId }
            );

            // Fetch.post não rejeita em erro HTTP: devolve o corpo { message }.
            if (!response || !('projection' in response)) {
                throw new Error(response?.message || 'Erro ao calcular a projeção populacional.');
            }
            return response.projection;
        },
        enabled: Boolean(cityId),
        staleTime: Infinity
    });

export default useCensusPopulationProjection;
